import React from 'react'

import TextInputField from 'components/Form/TextInputField'
import { SelectWithLabel } from 'components/Form'
import SelectCheckbox from '../../Marketing/Campaigns/CreateCampaigns/Filters/SelectCheckbox'
import CalendarField from './CalendarField'
import MultiBrandsAndDelegations from 'components/Form/MultiBrandsAndDelegations'
import { InputControls } from 'components/common'

import { lang } from 'utils/helpers'

import './styles.scss'

/**
 * It renders a form field based on the field type
 * @param props - {}
 * @param {object} field
 * @param {string} field.label
 * @param {string} field.name
 * @param {string} field.type text || select_one || select_one_many || date
 * @param {string} [field.className]
 * @param {string} [field.placeholder]
 * @param {array} [field.options]
 * @param {array} [field.contents] date field
 * @param {object} valueFilters redux filters
 * @param {Function} handleOnChange
 * @returns A component that will render a text input, a select input, or a calendar input.
 */
const FilterFields = (props) => {
  const { field, valueFilters, handleOnChange } = props

  if(!field) return <div></div>

  const { label = '', subtitle = '', placeholder='', name = '', className = '', options = [] } = field

  const labelCalendarDate = () =>
    valueFilters?.[name]?.[0] === '' && valueFilters?.[name]?.[1] === ''
      ? lang(placeholder || 'dashboard_select-date-range')
      : `${valueFilters?.[name]?.[0]} ${valueFilters?.[name]?.[1] !== '' ? '~' : ''} ${valueFilters?.[name]?.[1]}`

  switch(field.type){
    case 'text':
      return (
        <div className='container_filter_field'>
          <TextInputField
            classNameWrapper='text-filter-page'
            className={className}
            name={name}
            placeholder={lang(placeholder || 'dashboard_search')}
            value={valueFilters[name]}
            onChange={value => handleOnChange(value, name)}
          />
        </div>
      )
    case 'select_one':
      return (
        <div className='container_filter_field'>
          <SelectWithLabel
            classNameWrapper={`select-pages-filters ${className || ''}`}
            key={name}
            name={name}
            label={lang(label)}
            placeholder={lang(placeholder || 'dashboard_select')}
            options={options}
            value={{
              value: valueFilters[name],
              label: typeof valueFilters[name] === 'number' ?
              `${valueFilters[name]} ${lang('dashboard_results')}` :
                lang(`label_text_result_description_${valueFilters[name]}`)
            }}
            onChange={({ value }) => handleOnChange(value, name)}
          />
        </div>
      )
    case 'select_one_many':
      return (
        <div className='container_filter_field'>
          <SelectCheckbox
            classNameWrapper={`filters-options select-pages-filters ${className}`}
            label={lang(label)}
            placeholder={lang(placeholder || 'dashboard_select')}
            options={options}
            defaultValue={valueFilters[name]}
            onChangeCallback={value => handleOnChange(value || [], name)}
          />
        </div>
      )
    case 'date':
      return (
        <div className='container_filter_field field_date'>
          <CalendarField
            className={`select-page-date ${className || ''}`}
            imageUrl='icon-calendar.svg'
            name={name}
            label={lang(label)}
            subtitle={subtitle}
            valueFilters={valueFilters}
            text={labelCalendarDate()}
            handleOnChange={handleOnChange}
            isClear={valueFilters?.[name]?.join('')?.length > 0 ? true : false}
          />
        </div>
      )
    case 'brand_delegations':
      return (
        <div className='container_filter_field'>
          <MultiBrandsAndDelegations
            customClassNameContainer='select-pages-filters'
            label={lang(label)}
            placeholder={lang(placeholder || 'dashboard_select')}
            currentBrands={valueFilters.brands || []}
            currentDelegations={valueFilters.delegations || []}
            onChange={value => handleOnChange(value, 'brandsAndDelegations')}
          />
        </div>
      )
    case 'switch':
      return (
        <div className='container_filter_field'>
          <InputControls
            className='switch-filter'
            injectType='external'
            labelLeft={label}
            value={valueFilters[name]}
            onChange={value => handleOnChange(value, name)}
          />
        </div>
      )
    default:
      return null
  }
}

export default FilterFields